import {
  ExpenseManagementCategory,
  ExpenseManagementProject,
  ProjectsAndCategoriesPayload,
} from "redmond";

export interface ProjectsAndCategoriesOption {
  name: string;
  displayName: string;
  lowercaseDisplayName: string;
}

export interface ProjectsAndCategoriesLookups {
  projects: ProjectsAndCategoriesOption[];
  categories: ProjectsAndCategoriesOption[];
  // Category names allowed for a given project. Absent entry or undefined means "any category".
  categoryNamesByProject: Map<string, string[] | undefined>;
}

const toOption = (
  item: ExpenseManagementProject | ExpenseManagementCategory
): ProjectsAndCategoriesOption => ({
  name: item.name,
  displayName: item.displayName,
  lowercaseDisplayName: item.displayName.toLowerCase(),
});

// Builds the cross-filter lookups once per fetch, using the project side as the
// source of truth: a project with no categoryNames allows any category, so the
// map stores `undefined` (not an empty array) to keep that case unambiguous.
export const buildProjectsAndCategoriesLookups = (
  payload: ProjectsAndCategoriesPayload
): ProjectsAndCategoriesLookups => ({
  projects: payload.projects.map(toOption),
  categories: payload.categories.map(toOption),
  categoryNamesByProject: new Map(
    payload.projects.map((project) => [
      project.name,
      project.categoryNames?.length ? project.categoryNames : undefined,
    ])
  ),
});
